import { ChevronDown } from "lucide-react";

import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const PERIODS = ["WoW", "MoM"];

const PeriodToggle = ({ value, onChange }) => (
    <div
        role="tablist"
        aria-label="Comparison period"
        className="flex h-[38px] items-center rounded-[64px] border border-cm-p-outline-variation bg-cm-p-surface-container"
    >
        {PERIODS.map((period) => {
            const isActive = period === value;
            return (
                <button
                    key={period}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => onChange(period)}
                    className={cn("h-full rounded-[58px] px-4 text-sm/6 text-cm-p-text-primary", {
                        "border border-cm-p-outline bg-cm-p-surface font-medium": isActive,
                        "font-normal": !isActive,
                    })}
                >
                    {period}
                </button>
            );
        })}
    </div>
);

// Preview strip above the charts: the sample-data disclaimer on the left, the period controls on the right.
// The trailer type selector is intentionally static — the preview aggregates all trailer types.
export const AnalyticsToolbar = ({ period, onPeriodChange, className }) => (
    <div className={cn("flex w-full flex-col gap-3 px-0.5 sm:flex-row sm:items-center sm:justify-between", className)}>
        <div className="flex items-center gap-3">
            <span className="flex h-5 shrink-0 items-center rounded-[4px] bg-cm-p-container-green px-1.5 text-xs font-medium uppercase text-cm-p-on-container-green">
                <TranslatedText>preview</TranslatedText>
            </span>
            <TranslatedText className="text-sm text-cm-p-text-secondary">
                Sample data. Charts below are live, the numbers are not yours yet.
            </TranslatedText>
        </div>
        <div className="flex items-center gap-2">
            <div className="flex cursor-default items-center gap-3 rounded-[70px] border border-cm-p-outline bg-cm-p-surface px-4 py-2 text-sm font-medium text-cm-p-text-primary">
                <TranslatedText>All trailer types</TranslatedText>
                <ChevronDown className="size-3 text-cm-p-text-secondary" strokeWidth={2} />
            </div>
            <PeriodToggle value={period} onChange={onPeriodChange} />
        </div>
    </div>
);
